import { CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Formik } from 'formik';
import { ProductCreateWithVariants } from 'src/app/api/openapi';
import CreateProductForm from './CreateProductForm';
import { ProductClient } from 'src/app/api/clients/products';
import { useState } from 'react';
import { uploadMediaForProduct } from 'src/app/api/hooks/media';

const CreateProduct = () => {
  const navigate = useNavigate();
  const { orgId } = useParams();
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateProduct = (values: ProductCreateWithVariants) => {
    if (!orgId) return alert("Can't create product. Missing organization ID.");
    setIsLoading(true);
    // @ts-ignore
    const { filesToUpload, ...newProduct } = values;
    if (newProduct.has_adult_consideration === 'null')
      delete newProduct.has_adult_consideration;
    ProductClient.createProduct(orgId, newProduct).then(({ data: product }) => {
      if (!filesToUpload) return navigate(`/products/${orgId}/${product.id}`);
      uploadMediaForProduct(orgId, product.id, filesToUpload).then(() =>
        navigate(`/products/${orgId}/${product.id}`)
      );
    });
  };

  return (
    <>
      {isLoading && <CircularProgress />}
      <Formik
        initialValues={{
          id: '',
          title: '',
          subtitle: '',
          description: '',
          html_description: '',
          varies_by: [],
          categories: [],
          tags: [],
          has_adult_consideration: 'null',
          is_published: false,
          is_ebt_eligible: false,
          brand_id: '',
          variants: [
            {
              sku: '',
              gtin: '',
              gtin12: '',
              gtin8: '',
              varies_by: [],
              suggested_prices: [],
              ordinal: 1,
            },
          ],
        }}
        onSubmit={handleCreateProduct}
      >
        {CreateProductForm}
      </Formik>
    </>
  );
};

export default CreateProduct;
